import { FC } from 'react';
import styled from '@emotion/styled';

import { Gray_Light_200, Typography } from '@common/styles';

interface Props {
  title: string;
  isAd: boolean;
}

export const Title: FC<React.PropsWithChildren<Props>> = ({ title, isAd }) => (
  <SC.SectionTitle className={Typography.BODY_18_SEMIBOLD}>
    {title}
    <span className={Typography.CAPTION_11_REGULAR}>{isAd && 'Sponsored'}</span>
  </SC.SectionTitle>
);

const SC = {
  SectionTitle: styled.h4`
    display: flex;
    align-items: center;
    padding: 20px 0 16px;
    justify-content: space-between;

    span {
      color: ${Gray_Light_200};
    }
  `,
};
